import { Await } from "react-router";
import { SectionSupplementsContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import WealthSupplementsPageContent from "./WealthSupplementsPageContent";

export default function WealthSupplementsPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<SectionSupplementsContext, string>>();

  if (context && context.statusCode !== HttpStatusCode.Ok) {
    // StatusCode is not 200
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (context && !context.payload) {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: SectionSupplementsContext) => {
        if (kind !== "section") {
          // Error or kind is not "newsletter"
          return <CustomError statusCode={context.statusCode} />;
        }

        // StatusCode is 200 and kind is "newsletter"
        return <WealthSupplementsPageContent data={data} />;
      }}
    </Await>
  );
}
